import { Injectable } from "@nestjs/common";
import { EINPROGRESS } from "constants";
import { RmEvaluationSamples } from "../rm-evaluation-samples.entity";
import { RmEvaluation } from "../rm-evaluation.entity";
import { RmEvaluationSamplesInfo } from "./rm-evaluation-samples.dto";
import { RmEvaluationInfo } from "./rm-evaluation.dto";

@Injectable()
export class RmEvaluationAdapter{

    public convertDtoToEntity( dto: RmEvaluationInfo): RmEvaluation{
        const entity = new RmEvaluation();
        entity.vehicleId = dto.vehicleId;
        entity.arrivalTime = dto.arrivalTime;
        entity.startTimeOfObv = dto.startTimeOfObv;
        entity.freqencyOfInsp = dto.freqencyOfInsp??500;
        entity.batchNumber = dto.batchNumber;
        entity.centerOrSourceCode = dto.centerOrSourceCode;
        entity.totalQuantity = dto.totalQuantity;
        entity.noOfSamplesDrawn = dto.noOfSamplesDrawn;
        entity.remarks = dto.remarks;
        entity.grnId = dto.grnId;
        entity.grnItemId = dto.grnItemId;
        if(dto.rmEvaluationId){
            entity.rmEvaluationId = dto.rmEvaluationId;
            entity.updatedUser = dto.updatedUser;
        }else{
            entity.createdUser = dto.createdUser;
        }

        const RmEvalSamplesInfo: RmEvaluationSamples[] = [];

        for(const SamplesDto of dto.RmEvalSamplesInfo){
            const rmEvalSample = new RmEvaluationSamples();
            rmEvalSample.rmEvaluationId = dto.rmEvaluationId;
            rmEvalSample.time = SamplesDto.time;
            rmEvalSample.sampleNo = SamplesDto.sampleNo;
            rmEvalSample.species = dto.productId;
            rmEvalSample.temperature = SamplesDto.temperature;
            rmEvalSample.generalAppearance = SamplesDto.generalAppearance;
            rmEvalSample.generalOdour = SamplesDto.generalOdour;
            rmEvalSample.freshness = SamplesDto.freshness;
            rmEvalSample.dehydration = SamplesDto.dehydration;
            rmEvalSample.discolouration = SamplesDto.discolouration;
            rmEvalSample.deterioration = SamplesDto.deterioration;
            rmEvalSample.blackSpotOrTail = SamplesDto.blackSpotOrTail;
            rmEvalSample.looseShells = SamplesDto.looseShells;
            rmEvalSample.brokenOrDamagedPcs = SamplesDto.brokenOrDamagedPcs;
            rmEvalSample.fungalGrowth = SamplesDto.fungalGrowth;
            rmEvalSample.softSpecies = SamplesDto.softSpecies;
            rmEvalSample.droopingHead = SamplesDto.droopingHead;
            rmEvalSample.foreignMatter = SamplesDto.foreignMatter;
            rmEvalSample.sulphiteKit = SamplesDto.sulphiteKit;
            rmEvalSample.pests = SamplesDto.pests;
            rmEvalSample.muddyOdour = SamplesDto.muddyOdour;
            rmEvalSample.cookedTexture = SamplesDto.cookedTexture;
            rmEvalSample.cookedFlavor = SamplesDto.cookedFlavor;
            rmEvalSample.parasite = SamplesDto.parasite;
            if(SamplesDto.rmEvaluationSampleId){
                rmEvalSample.rmEvaluationSampleId = SamplesDto.rmEvaluationSampleId;
                rmEvalSample.updatedUser = dto.updatedUser;
            }else{
                rmEvalSample.createdUser = dto.createdUser;
            }
            RmEvalSamplesInfo.push(rmEvalSample);
        }
        entity.RmEvalSamplesInfo = RmEvalSamplesInfo;
        return entity;
    }

    public convertEntityToDto( entity: RmEvaluation): RmEvaluationInfo{
        const dto = new RmEvaluationInfo;
        dto.rmEvaluationId = entity.rmEvaluationId;
        dto.vehicleId = entity.vehicleId;
        dto.arrivalTime = entity.arrivalTime;
        dto.startTimeOfObv = entity.startTimeOfObv;
        dto.freqencyOfInsp = entity.freqencyOfInsp;
        dto.batchNumber = entity.batchNumber;
        dto.centerOrSourceCode = entity.centerOrSourceCode;
        dto.totalQuantity = entity.totalQuantity;
        dto.noOfSamplesDrawn = entity.noOfSamplesDrawn;
        dto.remarks = entity.remarks;
        dto.createdUser = entity.createdUser;
        dto.createdAt = entity.createdAt;
        dto.updatedAt = entity.updatedAt;
        dto.updatedUser = entity.updatedUser;
        dto.versionFlag = entity.versionFlag;
        dto.RmEvalSamplesInfo = entity.RmEvalSamplesInfo;
        return dto;
    }
}